import React from 'react'

const Error404 = () => {
  return (
    <div style={{height : "100vh" , backgroundColor:"red"}}>
      Error 404 Page not found !
    </div>
  )
}

export default Error404
